// extracted by mini-css-extract-plugin
export default {"App":"App_App__FUko1","contact":"App_contact__4L-VS","stop_overflow":"App_stop_overflow__X+Ta7","backToTop":"App_backToTop__wNo64","fa-brands":"App_fa-brands__Vd-mf"};